<script>
  import { onMount } from 'svelte';

  let { size = 'md', color = 'red', speed = 1 } = $props();

  const sizes = $derived(
    {
      sm: { w: 30, h: 30 },
      md: { w: 50, h: 50 },
      lg: { w: 100, h: 100 },
      xl: { w: 150, h: 150 },
      '2xl': { w: 300, h: 300 },
    }[size],
  );

  const colors = $derived(
    {
      red: '#F82F2A',
      white: '#ffffff',
      black: '#000000',
    }[color],
  );

  let canvas = $state();
  const numPoints = 200;
  let currentStep = 0;

  onMount(() => {
    const { width, height } = canvas;
    const ctx = canvas.getContext('2d');

    const clear = () => {
      ctx.clearRect(0, 0, width, height);
    };

    const draw = (t) => {
      ctx.fillStyle = colors;
      ctx.beginPath();

      const fa = (Math.PI * 2) / numPoints;
      const rad = width * 0.4;

      for (let index = 0; index < numPoints; index++) {
        let x = Math.cos(fa * index) * rad;
        let y = Math.sin(fa * index) * rad;

        x *=
          1 +
          Math.cos(
            +1 * t * 0.01 + 1.0 * (index + 1.2 * Math.sin(t * 0.06)) * fa,
          ) *
            Math.sin(t * 0.005) *
            0.22 *
            Math.cos(fa * index);

        y *=
          1 +
          Math.sin(
            -1 * t * 0.01 + 1.5 * (index + 1.2 * Math.sin(t * 0.05)) * fa,
          ) *
            Math.sin(t * 0.007) *
            0.22 *
            Math.sin(fa * index);

        x += width / 2;
        y += width / 2;

        if (!index) {
          ctx.moveTo(x, y);
        } else {
          ctx.lineTo(x, y);
        }
      }

      ctx.fill();
    };

    let animationFrame;
    const anim = (ms) => {
      clear();
      currentStep += speed;
      const scaledMs = (ms * speed) / (1000 / 60);
      draw(scaledMs);
      animationFrame = requestAnimationFrame(anim);
    };

    anim();
    return () => cancelAnimationFrame(animationFrame);
  });
</script>

<canvas bind:this={canvas} width={sizes.w} height={sizes.h} />
